"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireWildcard(require("react"));
var _querystring = _interopRequireDefault(require("querystring"));
var _container = _interopRequireDefault(require("../core/container"));
var _link = _interopRequireDefault(require("../core/link"));
var _button = _interopRequireDefault(require("../core/button"));
var _fullWidth = require("./full-width");
var _loginForm = _interopRequireDefault(require("../core/login-form"));
var _notFound = _interopRequireDefault(require("../not-found"));
var _articles = _interopRequireDefault(require("../articles"));
var _checkout = _interopRequireDefault(require("../checkout"));
var _help = _interopRequireDefault(require("../help"));
var _settings = _interopRequireDefault(require("../settings"));
var _submitNewPayment = _interopRequireDefault(require("../submit-new-payment"));
var _year = _interopRequireDefault(require("../year"));
var _developmentModeWarning = _interopRequireDefault(require("./development-mode-warning"));
var _navBar = _interopRequireDefault(require("./nav-bar"));
var _footerMain = _interopRequireDefault(require("../core/footer-main"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const environment = "production" || 'development';
var _ref = /*#__PURE__*/_react.default.createElement(_developmentModeWarning.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: false,
  path: "/year/:yearID",
  component: _year.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: "/checkout",
  component: _checkout.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: "/submit-new-payment",
  component: _submitNewPayment.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: false,
  path: "/settings",
  component: _settings.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: true,
  path: "/help",
  component: _help.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  exact: false,
  path: "/articles",
  component: _articles.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
}));
var _ref4 = /*#__PURE__*/_react.default.createElement(_footerMain.default, null);
class Navigation extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_toggleLogin", () => {
      const {
        history,
        location
      } = this.props;
      const query = this._getQuery();
      const isLoggingIn = query.isLoggingIn === 'true';
      history.push({
        ...location,
        search: this._setIsLoggingIn(query, !isLoggingIn)
      });
    });
    _defineProperty(this, "_render", isFullWidth => {
      const {
        location
      } = this.props;
      const query = this._getQuery();
      const isLoggingIn = query.isLoggingIn === 'true';
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_navBar.default, {
        onToggleLogin: this._toggleLogin
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "m-t-3"
      }, _ref, /*#__PURE__*/_react.default.createElement(_container.default, {
        fluid: isFullWidth
      }, _ref2, isLoggingIn ? /*#__PURE__*/_react.default.createElement(_loginForm.default, {
        successUrl: location.pathname + this._setIsLoggingIn(query, false),
        onCancel: this._toggleLogin
      }) : _ref3)), _ref4);
    });
  }
  _getQuery() {
    const {
      location
    } = this.props;
    return _querystring.default.parse(location.search.substr(1));
  }
  _setIsLoggingIn(query, isLoggingIn) {
    const newQuery = {};
    Object.keys(query).forEach(key => {
      if (key !== 'isLoggingIn') {
        newQuery[key] = query[key];
      }
    });
    if (isLoggingIn) {
      newQuery.isLoggingIn = 'true';
    }
    const search = _querystring.default.stringify(newQuery);
    return search.length ? '?' + search : '';
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_fullWidth.IsFullWidth, {
      render: this._render
    });
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactRouterDom.withRouter)(Navigation);